/**
 * Bildrechte/Fotografen anzeigen
 * @namespace Copyrights
 * @aka COMMON.Copyrights
 *
 */
COMMON.Copyrights = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'copyrights';
  var DATA_KEY = 'common.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_TOGGLE: '[data-toggle="copyrights"]',
    COPYRIGHTS: '#copyright',
    CONTENT: '#content',
    FOOTER: '#footer',
    HEADER: '#header > *'
  };

  var Template = {
    COPYRIGHTS: '<div id="copyright" class="container" style="display: none;">'
      + '<p class="h5">Bildrechte auf dieser Seite</p>'
      + '<dl>{rows}</dl>'
      + '<button data-toggle="copyrights">Bereich schließen</button>'
      + '</div>',
    ROW: '<dt>'
      + '<img src="{src}" srcset="{srcset}" sizes="{sizes}" alt="" />'
      + '</dt>'
      + '<dd>{description}</dd>'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Copyrights = function () {

    function Copyrights(element) {
      COMMON.Utils._classCallCheck(this, Copyrights);

      var self = this;

      self.element = element;
    }

    // public
    Copyrights.prototype.dispose = function dispose() {
      $(this.element).off(EVENT_KEY);
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    Copyrights.prototype.show = function show(element) {
      var self = this;
      self.element = element || this.element;

      var $list = $('<dl></dl>');

      // Alle Bilder einsammeln und filtern
      var $content = $(Selector.CONTENT),
        srcs = [];

      $('img, figure', $content)
        .not('.nocopyright, .slick-cloned, [src*="xiti.com/"], [src*="ping.chartbeat.net/"], [src*="google-analytics.com/"], [src*="/osm/"], [src^="data:"], .emojione')
        .each(function () {
          var $el = $(this),
            src, normalizedSrc, row;

          if ($el.is('img')) {
            src = $el.attr('src');
            if ('undefined' === typeof src) {
              src = $el.attr('data-src');
            }
          } else if ($el.is('figure') && ($el.has('span[data-url]') || $el.has('div[class~="audio-player"]').length)) {
            src = $el.find('span[itemprop~="image"] link[itemprop~="url"]').last().attr('href');
          } else {
            return true;
          }

          if ('undefined' === typeof src) {
            return true;
          }

          // Duplikate ausschließen
          normalizedSrc = COMMON.Utils.parseUrl(src.replace(/~(.+)?(?=\.)/gi, '')).relative;
          if (-1 !== $.inArray(normalizedSrc, srcs))
            return true;

          srcs.push(normalizedSrc);

          // Anzeigen
          if ($el.is('img')) {
            var description = ($el.attr('alt') + ' ' || '');
            if (!description.includes('(Foto: ')) {
              if ($el.attr('data-copyright')) {
                description += ' (';
                description += $el.attr('data-copyright').trim();
                description += ')';
              } else if ($el.attr('title')) {
                description = $el.attr('title');
              }
            }
            row = COMMON.Utils.template(Template.ROW, {
              src: src,
              srcset: $el.attr('srcset') || $el.attr('data-srcset') || '',
              sizes: $el.attr('sizes') || 'auto',
              description: description
            });
          } else if ($el.is('figure')) {
            var caption = [],
              copyrightHolder = [];
            $el.find('[itemprop~=caption]').each(function () {
              var text = $(this).text().trim();
              if (text.length === 0) {
                text = $(this).attr('content')
              }
              caption.push(text)
            });

            $el.find('[itemprop~=copyrightHolder]').each(function () {
              var copyright = $(this).text().trim();
              if (copyright.length === 0) {
                copyright = $(this).find('[itemprop~=name]').attr('content')
              }
              copyrightHolder.push(copyright)
            });

            row = COMMON.Utils.template(Template.ROW, {
              src: src,
              srcset: '',
              sizes: '',
              description: [caption.join(' '), '(Foto: ' + copyrightHolder.join(', ') + ')'].join(' ').trim()
            });
          }

          $list.append(row);
        });

      // Bei Navigation Liste schließen
      $(document).on(Event.PJAX_DATA_API, function () {
        Copyrights._jQueryInterface.call($(self.element), 'hide');
      });

      // Liste im Footer ausgeben
      var copyright = COMMON.Utils.template(Template.COPYRIGHTS, {
        rows: $list.html()
      });
      $(copyright)
        .appendTo(Selector.FOOTER)
        .fadeIn(218);

      $('html, body').animate({scrollTop: ($('#copyright').offset().top)}, 'slow');
    };

    Copyrights.prototype.hide = function hide(element) {
      var self = this;
      self.element = element || this.element;

      var $copyright = this._copyright || $(Selector.COPYRIGHTS);

      if ($copyright.length <= 0 || !$copyright.filter(':visible'))
        return;

      $copyright.fadeOut(218, function () {
        $(this).remove()
      });

      // Eventlistener für Navigation deaktivieren
      $(document).off(Event.PJAX_DATA_API);

      $copyright = null;
    };

    Copyrights.prototype.toggle = function toggle(element) {
      var self = this;
      self.element = element || this.element;

      var $copyright = this._copyright || $(Selector.COPYRIGHTS);

      $(document).trigger('common:pixel:pageview');

      if ($copyright.length > 0 && $copyright.filter(':visible'))
        self.hide();
      else
        self.show();
    };

    // static
    Copyrights._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : COMMON.Utils._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Copyrights(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    return Copyrights;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    event.stopPropagation();
    Copyrights._jQueryInterface.call($(this), 'toggle');
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Copyrights._jQueryInterface;
  $.fn[NAME].Constructor = Copyrights;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Copyrights._jQueryInterface;
  };

  return Copyrights;

}(window.jQuery);
